import { createSlice } from '@reduxjs/toolkit'
import { sortByProp } from '../../../../../../helpers/common'
import { register } from '../../../../../../helpers/reducerRegistry'
import { SORT_DIRECTION } from '../../../../../../utils/common'
import { SORT_BY } from '../../constant'
import {
  handleDataImportExportTrade,
  handleDataImportExportValue,
  handleYearImportExportTrade,
  handleYearImportExportValue,
} from '../helpers'
import { getImportExportData } from './thunk'

const slice = createSlice({
  name: 'companyAnalysis/industryOverview/macroeconomics/importExport',
  initialState: {
    isLoading: true,
    ids: [],
    rawData: [],
    years: [],
    year: undefined,
    sortBy: SORT_BY.IMPORT_DESCENDING,
    isShowTradeData: true,
    isShowValueData: true,
    sortTable: {
      sortBy: '',
      sortDirection: '',
    },
    growRateHeaders: [],
    growRateData: {},
    valueHeaders: [],
    valueData: {},
  },
  reducers: {
    resetStore: (state) => {
      state.isLoading = true
      state.ids = []
      state.rawData = []
      state.years = []
      state.year = undefined
      state.sortBy = SORT_BY.IMPORT_DESCENDING
      state.sortTable = {
        sortBy: '',
        sortDirection: '',
      }
      state.growRateHeaders = []
      state.growRateData = {}
      state.valueHeaders = []
      state.valueData = {}
    },
    changeYear: (state, action) => {
      state.year = action.payload
    },
    changeSortBy: (state, action) => {
      state.sortBy = action.payload
    },
    changeIsShowTradeData: (state, action) => {
      state.isShowTradeData = action.payload
    },
    changeIsShowValueData: (state, action) => {
      state.isShowValueData = action.payload
    },
    sort: (state, action) => {
      const { sortTable, type } = action.payload
      state.sortTable = sortTable

      if (sortTable.sortDirection) {
        state.ids = sortByProp(
          Object.values(state[type]),
          sortTable.sortBy,
          sortTable.sortDirection === SORT_DIRECTION.DESC,
          false,
        ).map((item) => item.id)
      } else {
        state.ids = [...new Set(state.rawData.map((item) => item.vsicId))]
      }
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getImportExportData.pending, (state) => {
      state.isLoading = true
      state.ids = []
      state.rawData = []
      state.years = []
      state.year = undefined
      state.sortBy = SORT_BY.IMPORT_DESCENDING
      state.sortTable = {
        sortBy: '',
        sortDirection: '',
      }
      state.growRateHeaders = []
      state.growRateData = {}
      state.valueHeaders = []
      state.valueData = {}
    })
    builder.addCase(
      getImportExportData.fulfilled,
      (state, { payload = [] }) => {
        state.isLoading = false
        state.rawData = sortByProp(payload, 'year', false)
        state.ids = [...new Set(payload.map((item) => item.vsicId))]
        state.years = [...new Set(payload.map((item) => item.year))].sort()
        state.year = state.years.length ? state.years[0] : undefined

        state.growRateHeaders = handleYearImportExportTrade(state.years)
        state.growRateData = handleDataImportExportTrade(
          payload,
          state.ids,
          state.years,
        )
        state.valueHeaders = handleYearImportExportValue(state.years)
        state.valueData = handleDataImportExportValue(
          payload,
          state.ids,
          state.years,
        )
      },
    )

    builder.addCase(getImportExportData.rejected, (state, action) => {
      state.isLoading = action.payload.isLoading
    })
  },
})

export const selectRawData = (state) => state[slice.name].rawData
export const selectYear = (state) => state[slice.name].year
export const selectIds = (state) => state[slice.name].ids
export const selectIsLoading = (state) => state[slice.name].isLoading
export const selectYears = (state) => state[slice.name].years
export const selectSortBy = (state) => state[slice.name].sortBy
export const selectSortTable = (state) => state[slice.name].sortTable
export const selectIsShowTradeData = (state) =>
  state[slice.name].isShowTradeData
export const selectIsShowValueData = (state) =>
  state[slice.name].isShowValueData
export const selectGrowRateHeaders = (state) =>
  state[slice.name].growRateHeaders
export const selectGrowRateItem = (rowId, colId) => (state) =>
  state[slice.name].growRateData[rowId][colId]
export const selectValueHeaders = (state) => state[slice.name].valueHeaders
export const selectValueItem = (rowId, colId) => (state) =>
  state[slice.name].valueData[rowId][colId]

export const {
  resetStore,
  changeYear,
  changeSortBy,
  changeIsShowTradeData,
  changeIsShowValueData,
  sort,
} = slice.actions

register(slice.name, slice.reducer)
